import React, { memo, useState, useEffect, useCallback } from 'react'
import { Form, Select, TreeSelect, Space } from 'antd'
import styles from '../../index.module.less'
import stylesTreeSelect from './index.module.less'
import { LayoutEnum } from '../../enum'

const Index = (props: any) => {
  const { field, onChange, value } = props
  const {
    width,
    label,
    placeholder = '请选择',
    layout,
    options,
    defaultValue,
    allowClear,
    showSearch,
    optionFilterProp = 'label',
    multiple,
    selectConfig,
  } = field

  // const [inputValue, setInputValue] = useState('')
  const triggerChange = v => {
    onChange?.(v)
  }
  const handleInputValueChange = v => {
    triggerChange(v)
  }
  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          {/* <div className={styles.addon}>{label}</div> */}
          {label && <div className={styles.addon}>{label}</div>}
          <TreeSelect
            // optionFilterProp={optionFilterProp}
            showSearch={showSearch}
            popupClassName={stylesTreeSelect.treeSelectDropdown}
            maxTagCount={1}
            allowClear={allowClear}
            value={value}
            style={{ width }}
            placeholder={placeholder || `请选择${label}`}
            treeData={options}
            multiple={multiple}
            treeCheckable={true}
            showCheckedStrategy={TreeSelect}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            onChange={handleInputValueChange}
            fieldNames={{
              label: 'dictName',
              value: 'dictCode',
              children: 'children',
            }}
            treeNodeFilterProp='dictName'
            {...selectConfig}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          {/* <div className={styles.addon}>{label}</div> */}
          {label && <div className={styles.addon}>{label}</div>}
          {/* <Select
            optionFilterProp={optionFilterProp}
            showSearch={showSearch}
            maxTagCount={1}
            allowClear={allowClear}
            value={value}
            style={{ width }}
            placeholder={placeholder || `请选择${label}`}
            options={options}
            mode={multiple}
            onChange={handleInputValueChange}
            {...selectConfig}
          /> */}
          <TreeSelect
            // optionFilterProp={optionFilterProp}
            showSearch={showSearch}
            popupClassName={stylesTreeSelect.treeSelectDropdown}
            maxTagCount={1}
            allowClear={allowClear}
            value={value}
            style={{ width }}
            placeholder={placeholder || `请选择${label}`}
            treeData={options}
            multiple={multiple}
            treeCheckable={true}
            showCheckedStrategy={TreeSelect}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            onChange={handleInputValueChange}
            fieldNames={{
              label: 'dictName',
              value: 'dictCode',
              children: 'children',
            }}
            treeNodeFilterProp='dictName'
            {...selectConfig}
          />
        </div>
      )}
    </div>
  )
}

export default Index
